"use client";

import { c as _c } from "react/compiler-runtime";
import { ROUTES } from "@/lib/routes";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { SOLUTION_NAV_ITEMS } from "@/lib/solutions/nav";
import { USE_CASE_NAV_ITEMS } from "@/lib/use-cases/nav";
import Image from "next/image";
import Link from "next/link";
import { useCallback, useEffect, useRef, useState } from "react";
import { usePathname } from "next/navigation";
function ChevronDown(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  const t1 = className || "h-4 w-4";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M4 6l4 4 4-4" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = <svg className={t1} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth={2}>{t2}</svg>;
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}
function TemplatesIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="h-5 w-5" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth={1.5}><path d="M3 6.5V5a2 2 0 0 1 2-2h2.5l1.5 2H15a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6.5Z" /><path d="M8 10h4M8 13h2" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function IntegrationsIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="h-5 w-5" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth={1.5}><circle cx="10" cy="4" r="2" /><circle cx="4" cy="14" r="2" /><circle cx="16" cy="14" r="2" /><path d="M10 6v4M8.5 11.5 6 12.5M11.5 11.5 14 12.5" /><circle cx="10" cy="12" r="2" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function AgentsIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="h-5 w-5" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth={1.5}><circle cx="10" cy="7" r="3" /><path d="M3 17a7 7 0 0 1 14 0" /><circle cx="10" cy="7" r="0.5" fill="currentColor" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function BlogIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="h-5 w-5" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth={1.5}><path d="M5 3h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" /><path d="M3 8h6M3 12h3" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function DocsIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="h-5 w-5" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth={1.5}><path d="M4 4h5l1 1.5L11 4h5v12h-5l-1 1-1-1H4V4Z" /><path d="M10 5.5V16" /><path d="M6.5 8h2M6.5 10.5h1.5" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function LearnIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="h-5 w-5" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth={1.5}><path d="M2 8l8-4 8 4-8 4-8-4Z" /><path d="M5 10v4c0 1.5 2.5 3 5 3s5-1.5 5-3v-4" /><path d="M18 8v5" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function CompanyIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="h-5 w-5" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth={1.5}><path d="M3 17V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v12M3 17h10M3 17H1M13 17h2a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2h-2M13 17h6" /><path d="M6 7h3M6 10h3M6 13h3" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function ContactIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="h-5 w-5" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth={1.5}><rect x="2" y="3" width="16" height="14" rx="2" /><path d="M2 7l8 5 8-5" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function ExternalArrowIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="h-3 w-3" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth={1.5}><path d="M3 9l6-6M5 3h4v4" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function PlayIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor"><path d="M6.5 4.5v11l9-5.5-9-5.5Z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function VideoIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg className="text-ds-brand-500 h-5 w-5" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth={1.5}><rect x="2" y="4" width="12" height="12" rx="2" /><path d="M14 8l4-2v8l-4-2" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
const DOCS_URL = "https://docs.b3.fun";
const YOUTUBE_URL = "https://www.youtube.com/@B3OS_AI";
const productItems = [{
  label: "Templates",
  description: "Explore 100+ pre-audited workflow automation templates.",
  href: ROUTES.TEMPLATES,
  icon: TemplatesIcon
}, {
  label: "Integrations",
  description: "Explore all the integrations that B3OS has to offer.",
  href: ROUTES.INTEGRATIONS,
  icon: IntegrationsIcon
}, {
  label: "Agents",
  description: "MCP + x402 — onchain triggers, actions, and context for your agent.",
  href: ROUTES.AGENTS,
  icon: AgentsIcon
}];
const resourceItems = [{
  label: "Blog",
  description: "Product notes, launch logs, technical breakdowns, and operating memos.",
  href: ROUTES.BLOG,
  icon: BlogIcon
}, {
  label: "Documentation",
  description: "Guides, API references, and setup instructions for B3OS.",
  href: DOCS_URL,
  icon: DocsIcon,
  external: true
}, {
  label: "Learn",
  description: "Video walkthroughs and tutorials to get started with B3OS.",
  href: YOUTUBE_URL,
  icon: LearnIcon,
  external: true
}, {
  label: "Company",
  description: "Learn about the team and mission behind B3OS.",
  href: ROUTES.COMPANY,
  icon: CompanyIcon
}, {
  label: "Contact",
  description: "Get in touch with the B3OS team.",
  href: ROUTES.CONTACT,
  icon: ContactIcon
}];
const videoTutorials = [{
  title: "How to get started",
  description: "Let's build an onchain automation using B3OS.",
  href: YOUTUBE_URL
}, {
  title: "Create a Payment Link",
  description: "Create payment links for any token on any chain.",
  href: YOUTUBE_URL
}];
const featuredIntegrations = [{
  name: "Wallet",
  slug: "wallet"
}, {
  name: "Slack",
  slug: "slack"
}, {
  name: "Discord",
  slug: "discord"
}, {
  name: "Farcaster",
  slug: "farcaster"
}, {
  name: "Telegram",
  slug: "telegram-bot"
}, {
  name: "Coinbase",
  slug: "coinbase-business"
}, {
  name: "Shopify",
  slug: "shopify"
}, {
  name: "Polymarket",
  slug: "polymarket"
}];

// Nav items for the Solutions and Use Cases dropdowns. Imported from
// thin `nav.ts` files so the client bundle for this `"use client"`
// header doesn't pull in the full landing-page content (capabilities,
// FAQs, sub-topic copy, …) attached to `SOLUTION_SEGMENTS` and
// `USE_CASES`. Drift between nav slugs and canonical data slugs is
// caught at test time by `lib/{solutions,use-cases}/nav.test.ts`.
const solutionNavItems = SOLUTION_NAV_ITEMS;
const useCaseNavItems = USE_CASE_NAV_ITEMS;
const navPillClass = (isActive: boolean, hasChevron: boolean) => `flex h-9 items-center gap-1 rounded-lg border py-1.5 text-base font-medium leading-label outline-none transition-all ${isActive ? "border-ds-neutral-200 bg-white text-ds-text-secondary shadow-ds-soft" : "border-transparent text-ds-text-secondary hover:border-ds-neutral-200 hover:bg-white hover:text-ds-text-primary hover:shadow-ds-soft"} ${hasChevron ? "pl-3 pr-1.5" : "px-3"}`;
function DropdownNavItem(t0) {
  const $ = _c(26);
  const {
    icon: Icon,
    label,
    description,
    href,
    external
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="to-ds-neutral-300 pointer-events-none absolute -left-3 top-1/2 h-px w-[46px] -translate-y-1/2 bg-gradient-to-r from-transparent transition-all group-hover/item:to-[rgba(86,114,255,0.5)]" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="pointer-events-none absolute left-1/2 top-1/2 h-px w-[43px] -translate-x-1/2 -translate-y-1/2 bg-gradient-to-r from-transparent via-zinc-400/40 to-transparent transition-colors group-hover/item:via-[rgba(86,114,255,0.6)]" />;
    t3 = <div className="pointer-events-none absolute left-1/2 top-1/2 h-[43px] w-px -translate-x-1/2 -translate-y-1/2 bg-gradient-to-b from-transparent via-zinc-400/40 to-transparent transition-colors group-hover/item:via-[rgba(86,114,255,0.6)]" />;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== Icon) {
    t4 = <div className="relative flex shrink-0 items-center p-0.5"><div className="relative flex items-center justify-center rounded-full bg-black/5 p-0.5">{t2}{t3}<div className="shadow-ds-soft-pressed border-ds-neutral-300 relative flex size-9 items-center justify-center rounded-full border bg-white transition-all group-hover/item:border-[rgba(47,67,255,0.3)] group-hover/item:shadow-[1px_8px_5px_0px_rgba(47,67,255,0.05),0px_3px_3px_0px_rgba(47,67,255,0.1),0px_1px_2px_0px_rgba(47,67,255,0.1)]"><div className="group-hover/item:text-ds-brand-500 text-ds-text-secondary transition-colors"><Icon /></div></div></div></div>;
    $[3] = Icon;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== label) {
    t5 = <span className="group-hover/item:text-ds-brand-600 text-ds-text-secondary leading-label text-base font-medium transition-colors">{label}</span>;
    $[5] = label;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== external) {
    t6 = external && <ExternalArrowIcon />;
    $[7] = external;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div className="flex items-center gap-1.5">{t5}{t6}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== description) {
    t8 = <p className="text-sm leading-5 text-black/50">{description}</p>;
    $[12] = description;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7 || $[15] !== t8) {
    t9 = <div className="flex min-w-0 flex-1 flex-col gap-1 pt-1.5">{t7}{t8}</div>;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t4 || $[18] !== t9) {
    t10 = <div className="group/item rounded-ds-sm relative flex gap-3 p-3 transition-colors hover:bg-[rgba(47,67,255,0.07)]">{t1}{t4}{t9}</div>;
    $[17] = t4;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const content = t10;
  if (external) {
    let t11;
    if ($[20] !== content || $[21] !== href) {
      t11 = <a href={href} target="_blank" rel="noopener noreferrer">{content}</a>;
      $[20] = content;
      $[21] = href;
      $[22] = t11;
    } else {
      t11 = $[22];
    }
    return t11;
  }
  let t11;
  if ($[23] !== content || $[24] !== href) {
    t11 = <Link href={href}>{content}</Link>;
    $[23] = content;
    $[24] = href;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}

/**
 * SSR-friendly nav dropdown rendered as a semantic <ul> with <li>+<a>.
 * Desktop: hover-triggered panel below the nav pill.
 * Keyboard: Enter/Space toggles, Escape closes.
 */
function NavDropdown({
  label,
  items,
  viewAllHref,
  viewAllLabel,
  isOpen,
  onOpen,
  onClose,
  onCloseOthers,
  timeoutRef
}: {
  label: string;
  items: {
    name: string;
    href: string;
  }[];
  viewAllHref: string;
  viewAllLabel: string;
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  onCloseOthers: () => void;
  timeoutRef: React.RefObject<ReturnType<typeof setTimeout> | undefined>;
}) {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!isOpen) return;
    function handleClickOutside(e: MouseEvent) {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        onClose();
      }
    }
    function handleEscapeKey(e_0: KeyboardEvent) {
      if (e_0.key === "Escape") onClose();
    }
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [isOpen, onClose]);
  return <div ref={containerRef} className="relative" onMouseEnter={() => {
    clearTimeout(timeoutRef.current);
    onCloseOthers();
    onOpen();
  }} onMouseLeave={() => {
    timeoutRef.current = setTimeout(onClose, 150);
  }}>
      <button className={navPillClass(isOpen, true)} aria-expanded={isOpen} aria-haspopup="true" onClick={() => isOpen ? onClose() : onOpen()} onKeyDown={e_1 => {
      if (e_1.key === "Enter" || e_1.key === " ") {
        e_1.preventDefault();
        isOpen ? onClose() : onOpen();
      }
    }}>
        {label}
        <ChevronDown className={`h-4 w-4 transition-transform ${isOpen ? "rotate-180" : ""}`} />
      </button>
      <div className={`absolute left-1/2 top-full z-50 pt-2 transition-all ${isOpen ? "pointer-events-auto translate-y-0 opacity-100" : "pointer-events-none -translate-y-1 opacity-0"}`} style={{
      transform: `translateX(-50%) ${isOpen ? "translateY(0)" : "translateY(-4px)"}`
    }}>
        <div className="rounded-ds-xl shadow-ds-elev-3 border-ds-neutral-200 min-w-[220px] border bg-white/95 p-2 backdrop-blur-[6px]">
          <ul role="menu" className="flex flex-col gap-0.5">
            {items.map(item => <li key={item.name} role="none">
                <Link href={item.href} role="menuitem" className="text-ds-text-secondary hover:text-ds-brand-600 hover:bg-ds-surface-hover block rounded-lg px-3 py-2 text-sm font-medium transition-colors">
                  {item.name}
                </Link>
              </li>)}
          </ul>
          <div className="border-ds-neutral-200 mt-1.5 border-t pt-1.5">
            <Link href={viewAllHref} className="text-ds-brand-500 hover:text-ds-brand-600 block px-3 py-1.5 text-sm font-medium transition-colors">
              {viewAllLabel} &rarr;
            </Link>
          </div>
        </div>
      </div>
    </div>;
}

/**
 * Mobile expand/collapse section for dropdown content.
 */
function MobileNavSection(t0) {
  const $ = _c(16);
  const {
    label,
    items,
    viewAllHref,
    viewAllLabel,
    isExpanded,
    onToggle,
    onClose
  } = t0;
  const t1 = `h-4 w-4 transition-transform ${isExpanded ? "rotate-180" : ""}`;
  let t2;
  if ($[0] !== t1) {
    t2 = <ChevronDown className={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== isExpanded || $[3] !== label || $[4] !== onToggle || $[5] !== t2) {
    t3 = <button className="text-ds-text-secondary hover:bg-ds-surface-hover hover:text-ds-text-primary flex w-full items-center justify-between rounded-lg px-4 py-3 text-base font-medium transition-colors" aria-expanded={isExpanded} onClick={onToggle}>{label}{t2}</button>;
    $[2] = isExpanded;
    $[3] = label;
    $[4] = onToggle;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== isExpanded || $[8] !== items || $[9] !== onClose || $[10] !== viewAllHref || $[11] !== viewAllLabel) {
    t4 = isExpanded && <ul className="flex flex-col gap-0.5 pl-4">{items.map(item => <li key={item.name}><Link href={item.href} className="text-ds-text-secondary hover:bg-ds-surface-hover hover:text-ds-text-primary block rounded-lg px-4 py-2.5 text-sm font-medium transition-colors" onClick={onClose}>{item.name}</Link></li>)}<li><Link href={viewAllHref} className="text-ds-brand-500 hover:text-ds-brand-600 block rounded-lg px-4 py-2.5 text-sm font-medium transition-colors" onClick={onClose}>{viewAllLabel} →</Link></li></ul>;
    $[7] = isExpanded;
    $[8] = items;
    $[9] = onClose;
    $[10] = viewAllHref;
    $[11] = viewAllLabel;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <div>{t3}{t4}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}
export function HomepageHeader() {
  const pathname = usePathname();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [productOpen, setProductOpen] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);
  const [solutionsOpen, setSolutionsOpen] = useState(false);
  const [useCasesOpen, setUseCasesOpen] = useState(false);
  const [integrationsOpen, setIntegrationsOpen] = useState(false);
  const [mobileSolutionsOpen, setMobileSolutionsOpen] = useState(false);
  const [mobileUseCasesOpen, setMobileUseCasesOpen] = useState(false);
  const [mobileIntegrationsOpen, setMobileIntegrationsOpen] = useState(false);
  const productTimeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined);
  const resourcesTimeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined);
  const solutionsTimeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined);
  const useCasesTimeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined);
  const integrationsTimeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined);
  const activeNav = pathname === "/" ? "home" : pathname.startsWith("/pricing") ? "pricing" : pathname.startsWith("/solutions") ? "solutions" : pathname.startsWith("/use-cases") ? "useCases" : pathname.startsWith("/integrations") ? "integrations" : pathname.startsWith("/templates") || pathname.startsWith("/agents") ? "product" : pathname.startsWith("/blog") || pathname.startsWith("/company") || pathname.startsWith("/contact") ? "resources" : undefined;
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 0);
    handleScroll();
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const handleEscape = useCallback((e: KeyboardEvent) => {
    if (e.key === "Escape") setMobileMenuOpen(false);
  }, []);
  useEffect(() => {
    if (mobileMenuOpen) {
      document.addEventListener("keydown", handleEscape);
      return () => document.removeEventListener("keydown", handleEscape);
    }
  }, [mobileMenuOpen, handleEscape]);
  const closeAllDropdowns = useCallback(() => {
    setProductOpen(false);
    setResourcesOpen(false);
    setSolutionsOpen(false);
    setUseCasesOpen(false);
    setIntegrationsOpen(false);
  }, []);
  const solutionItems = solutionNavItems.map(s => ({
    name: s.name,
    href: `${ROUTES.SOLUTIONS}/${s.slug}`
  }));
  const useCaseItems = useCaseNavItems.map(u => ({
    name: u.name,
    href: `${ROUTES.USE_CASES}/${u.slug}`
  }));
  const integrationItems = featuredIntegrations.map(i => ({
    name: i.name,
    href: `${ROUTES.INTEGRATIONS}/app/${i.slug}`
  }));
  useEffect(() => {
    return () => {
      clearTimeout(productTimeoutRef.current);
      clearTimeout(resourcesTimeoutRef.current);
      clearTimeout(solutionsTimeoutRef.current);
      clearTimeout(useCasesTimeoutRef.current);
      clearTimeout(integrationsTimeoutRef.current);
    };
  }, []);
  return <header className={`fixed top-[var(--banner-offset,0px)] z-50 w-full transition-colors duration-200 ${scrolled ? "bg-ds-surface-primary/90 backdrop-blur-md" : ""}`}>
      <div className="mx-auto flex max-w-[1440px] items-center justify-between px-6 py-4 md:px-8">
        {/* Logo */}
        <Link href="/" className="flex w-[182px] items-center">
          <Image src="/images/homepage/b3-logo.svg" alt="B3OS" width={182} height={38} className="h-[38px] w-auto" priority />
        </Link>

        {/* Center Nav Pill */}
        <nav className="bg-ds-neutral-100 hidden items-center gap-1 rounded-xl p-1 md:flex">
          <Link href="/" className={navPillClass(activeNav === "home", false)}>
            Home
          </Link>

          <Popover open={productOpen} onOpenChange={setProductOpen}>
            <PopoverTrigger asChild>
              <button className={navPillClass(productOpen || activeNav === "product", true)} onMouseEnter={() => {
              clearTimeout(productTimeoutRef.current);
              closeAllDropdowns();
              setProductOpen(true);
            }} onMouseLeave={() => {
              productTimeoutRef.current = setTimeout(() => setProductOpen(false), 150);
            }}>
                Product
                <ChevronDown className={`h-4 w-4 transition-transform ${productOpen ? "rotate-180" : ""}`} />
              </button>
            </PopoverTrigger>
            <PopoverContent align="center" sideOffset={8} className="rounded-ds-xl shadow-ds-elev-3 border-ds-neutral-200 w-[340px] border bg-white/95 p-3 backdrop-blur-[6px]" onMouseEnter={() => clearTimeout(productTimeoutRef.current)} onMouseLeave={() => {
            productTimeoutRef.current = setTimeout(() => setProductOpen(false), 150);
          }} onOpenAutoFocus={e_0 => e_0.preventDefault()}>
              <div className="relative flex flex-col overflow-visible">
                <div className="absolute -bottom-3 -top-3 left-[34px] w-px bg-gradient-to-b from-transparent via-zinc-400/30 to-transparent" />
                {productItems.map(item => <DropdownNavItem key={item.label} {...item} />)}
              </div>
            </PopoverContent>
          </Popover>

          <NavDropdown label="Solutions" items={solutionItems} viewAllHref={ROUTES.SOLUTIONS} viewAllLabel="View all solutions" isOpen={solutionsOpen} onOpen={() => setSolutionsOpen(true)} onClose={() => setSolutionsOpen(false)} onCloseOthers={() => {
          closeAllDropdowns();
        }} timeoutRef={solutionsTimeoutRef} />

          <NavDropdown label="Use Cases" items={useCaseItems} viewAllHref={ROUTES.USE_CASES} viewAllLabel="View all use cases" isOpen={useCasesOpen} onOpen={() => setUseCasesOpen(true)} onClose={() => setUseCasesOpen(false)} onCloseOthers={() => {
          closeAllDropdowns();
        }} timeoutRef={useCasesTimeoutRef} />

          <NavDropdown label="Integrations" items={integrationItems} viewAllHref={ROUTES.INTEGRATIONS} viewAllLabel="All integrations" isOpen={integrationsOpen} onOpen={() => setIntegrationsOpen(true)} onClose={() => setIntegrationsOpen(false)} onCloseOthers={() => {
          closeAllDropdowns();
        }} timeoutRef={integrationsTimeoutRef} />

          <Popover open={resourcesOpen} onOpenChange={setResourcesOpen}>
            <PopoverTrigger asChild>
              <button className={navPillClass(resourcesOpen || activeNav === "resources", true)} onMouseEnter={() => {
              clearTimeout(resourcesTimeoutRef.current);
              closeAllDropdowns();
              setResourcesOpen(true);
            }} onMouseLeave={() => {
              resourcesTimeoutRef.current = setTimeout(() => setResourcesOpen(false), 150);
            }}>
                Resources
                <ChevronDown className={`h-4 w-4 transition-transform ${resourcesOpen ? "rotate-180" : ""}`} />
              </button>
            </PopoverTrigger>
            <PopoverContent align="center" sideOffset={8} className="rounded-ds-xl shadow-ds-elev-3 border-ds-neutral-200 w-[780px] border bg-white/95 p-0 backdrop-blur-[6px]" onMouseEnter={() => clearTimeout(resourcesTimeoutRef.current)} onMouseLeave={() => {
            resourcesTimeoutRef.current = setTimeout(() => setResourcesOpen(false), 150);
          }} onOpenAutoFocus={e_1 => e_1.preventDefault()}>
              <div className="flex">
                <div className="relative flex w-[350px] flex-col p-3">
                  <div className="absolute bottom-0 left-[46px] top-0 w-px bg-gradient-to-b from-transparent via-zinc-400/30 to-transparent" />
                  {resourceItems.map(item_0 => <DropdownNavItem key={item_0.label} {...item_0} />)}
                </div>
                <div className="rounded-r-ds-xl flex w-[430px] flex-col gap-3 self-stretch bg-zinc-50 px-6 pb-6 pt-8">
                  <div className="flex items-center justify-between">
                    <span className="text-ds-text-secondary text-base font-medium leading-6">Video Tutorials</span>
                    <a href={YOUTUBE_URL} target="_blank" rel="noopener noreferrer" className="text-ds-brand-500 flex items-center gap-1 text-sm font-medium">
                      <VideoIcon />
                      Watch all
                    </a>
                  </div>
                  <div className="flex flex-col gap-0.5">
                    {videoTutorials.map(video => <a key={video.title} href={video.href} target="_blank" rel="noopener noreferrer" className="rounded-ds-sm hover:bg-ds-surface-hover flex gap-3 px-3 py-3 transition-colors">
                        <div className="relative h-[99px] w-[176px] shrink-0 overflow-hidden rounded-lg border border-black/10">
                          <div className="bg-ds-neutral-200 flex h-full w-full items-center justify-center">
                            <div className="flex size-16 items-center justify-center rounded-full backdrop-blur-[8px]">
                              <PlayIcon />
                            </div>
                          </div>
                        </div>
                        <div className="flex min-w-0 flex-1 flex-col gap-3">
                          <div className="flex flex-col gap-1">
                            <p className="text-ds-text-secondary truncate text-sm font-medium leading-5">
                              {video.title}
                            </p>
                            <p className="text-sm leading-5 text-black/50">{video.description}</p>
                          </div>
                          <span className="text-ds-brand-500 flex items-center gap-1 text-sm font-medium">
                            <VideoIcon />
                            Watch video
                          </span>
                        </div>
                      </a>)}
                  </div>
                </div>
              </div>
            </PopoverContent>
          </Popover>

          <Link href={ROUTES.PRICING} className={navPillClass(activeNav === "pricing", false)}>
            Pricing
          </Link>
        </nav>

        <div className="hidden w-[182px] items-center justify-end md:flex">
          <Link href={ROUTES.DASHBOARD} className="shadow-ds-white from-ds-neutral-100 to-ds-neutral-200 text-ds-text-primary relative inline-flex h-11 items-center gap-2 overflow-clip rounded-xl bg-gradient-to-b px-6 py-3 text-base font-medium transition-transform hover:scale-[1.02]">
            Dashboard
            <span className="rounded-inherit shadow-ds-inner-light pointer-events-none absolute inset-0" />
          </Link>
        </div>

        <button className="flex h-10 w-10 items-center justify-center rounded-lg md:hidden" aria-label={mobileMenuOpen ? "Close menu" : "Open menu"} aria-expanded={mobileMenuOpen} onClick={() => setMobileMenuOpen(prev => !prev)}>
          {mobileMenuOpen ? <svg className="text-ds-text-primary h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path d="M6 18L18 6M6 6l12 12" />
            </svg> : <svg className="text-ds-text-primary h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path d="M4 6h16M4 12h16M4 18h16" />
            </svg>}
        </button>
      </div>

      {mobileMenuOpen && <div className="border-ds-neutral-200 border-t bg-white px-6 py-4 md:hidden">
          <nav className="flex flex-col gap-1">
            <Link href="/" className="text-ds-text-secondary hover:bg-ds-surface-hover hover:text-ds-text-primary rounded-lg px-4 py-3 text-base font-medium transition-colors" onClick={() => setMobileMenuOpen(false)}>
              Home
            </Link>
            <div className="text-ds-text-disabled px-4 py-2 text-xs font-medium uppercase tracking-wider">Product</div>
            {productItems.map(item_1 => <Link key={item_1.label} href={item_1.href} className="text-ds-text-secondary hover:bg-ds-surface-hover hover:text-ds-text-primary rounded-lg px-4 py-3 text-base font-medium transition-colors" onClick={() => setMobileMenuOpen(false)}>
                {item_1.label}
              </Link>)}
            <MobileNavSection label="Solutions" items={solutionItems} viewAllHref={ROUTES.SOLUTIONS} viewAllLabel="View all solutions" isExpanded={mobileSolutionsOpen} onToggle={() => setMobileSolutionsOpen(prev_0 => !prev_0)} onClose={() => setMobileMenuOpen(false)} />
            <MobileNavSection label="Use Cases" items={useCaseItems} viewAllHref={ROUTES.USE_CASES} viewAllLabel="View all use cases" isExpanded={mobileUseCasesOpen} onToggle={() => setMobileUseCasesOpen(prev_1 => !prev_1)} onClose={() => setMobileMenuOpen(false)} />
            <MobileNavSection label="Integrations" items={integrationItems} viewAllHref={ROUTES.INTEGRATIONS} viewAllLabel="All integrations" isExpanded={mobileIntegrationsOpen} onToggle={() => setMobileIntegrationsOpen(prev_2 => !prev_2)} onClose={() => setMobileMenuOpen(false)} />
            <div className="text-ds-text-disabled px-4 py-2 text-xs font-medium uppercase tracking-wider">
              Resources
            </div>
            {resourceItems.map(item_2 => item_2.external ? <a key={item_2.label} href={item_2.href} target="_blank" rel="noopener noreferrer" className="text-ds-text-secondary hover:bg-ds-surface-hover hover:text-ds-text-primary flex items-center gap-1 rounded-lg px-4 py-3 text-base font-medium transition-colors" onClick={() => setMobileMenuOpen(false)}>
                  {item_2.label}
                  <ExternalArrowIcon />
                </a> : <Link key={item_2.label} href={item_2.href} className="text-ds-text-secondary hover:bg-ds-surface-hover hover:text-ds-text-primary rounded-lg px-4 py-3 text-base font-medium transition-colors" onClick={() => setMobileMenuOpen(false)}>
                  {item_2.label}
                </Link>)}
            <Link href={ROUTES.PRICING} className="text-ds-text-secondary hover:bg-ds-surface-hover hover:text-ds-text-primary rounded-lg px-4 py-3 text-base font-medium transition-colors" onClick={() => setMobileMenuOpen(false)}>
              Pricing
            </Link>
            <Link href={ROUTES.DASHBOARD} className="shadow-ds-white from-ds-neutral-100 to-ds-neutral-200 text-ds-text-primary relative mt-2 inline-flex items-center justify-center overflow-clip rounded-xl bg-gradient-to-b px-4 py-3 text-center text-base font-medium" onClick={() => setMobileMenuOpen(false)}>
              Dashboard
              <span className="rounded-inherit shadow-ds-inner-light pointer-events-none absolute inset-0" />
            </Link>
          </nav>
        </div>}
    </header>;
}